"use client";

import dynamic from "next/dynamic";
import type { CardGridBlock } from "@mw/shared/payload-types";

const BlockCardGrid = dynamic(() => import("./BlockCardGrid").then(mod => mod.BlockCardGrid));

/**
 * Client wrapper for BlockCardGrid.
 * Uses dynamic import for proper code splitting in Next.js 15.
 */
export function BlockCardGridWrapper(props: CardGridBlock & { inverse?: boolean }) {
  return <BlockCardGrid {...props} />;
}
